<template>
  <div class="header-mobile-fixed d-flex flex-column" style="min-height: 100vh">
    <Menu v-if="!$route.meta.nomenu" />
    <!--begin::Content-->
    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
      <!--begin::Entry-->
      <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container">
          <!--begin::View-->
          <router-view></router-view>
          <!-- end::View -->
        </div>
        <!-- end::Container -->
      </div>
      <!-- end::Entry -->
    </div>
    <!-- end::Content -->
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/Menu.component";
import Footer from "@/components/Footer.component";
export default {
  name: "User",
  components: {
    Menu,
    Footer
  },
  data() {
    return {};
  }
};
</script>

<style src="../assets/scss/login.scss" lang="scss" scoped></style>

<style lang="scss">
.footer {
  margin-top: auto;
  width: 100%;
  display: table-row;
}
</style>
